import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enCommon from "./locales/en/common.json";
import geCommon from "./locales/ge/common.json";

const getInitialLanguage = () => {
  const storedLang = localStorage.getItem("language") || "en";
  return storedLang;
};

i18n.use(initReactI18next).init({
  resources: {
    en: { common: enCommon },
    ge: { common: geCommon },
  },
  lng: getInitialLanguage(),
  ns: ["common"],
  defaultNS: "common",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
